import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('planPackages.routes.index'),
        name: 'planPackages.index',
        component: () =>
            import(
                /* webpackChunkName: "plan-packages" */ '@/views/planPackages/Index.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('planPackages.breadcrumbs.index'),
                    to: { name: 'planPackages.index' },
                    disable: true,
                },
            ],
        },
    },
    {
        path: '/' + i18n.t('planPackages.routes.create'),
        name: 'planPackages.create',
        component: () =>
            import(
                /* webpackChunkName: "plan-packages" */ '@/views/planPackages/Create.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('planPackages.breadcrumbs.index'),
                    to: { name: 'planPackages.index' },
                    disable: false,
                },
                {
                    text: i18n.t('routes.breadcrumb.create'),
                    to: { name: 'planPackages.create' },
                    disable: true,
                },
            ],
        },
    },
    {
        path: '/' + i18n.t('planPackages.routes.edit') + '/:id',
        name: 'planPackages.edit',
        component: () =>
            import(
                /* webpackChunkName: "plan-packages" */ '@/views/planPackages/Edit.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('planPackages.breadcrumbs.index'),
                    to: { name: 'planPackages.index' },
                    disable: false,
                },
                {
                    text: i18n.t('form.actions.edit'),
                    to: { name: 'planPackages.edit' },
                    disable: true,
                },
            ],
        },
        props: true,
    },
]
